import React, { Component } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from 'auth_context';
import PublicHeader from './header';

const ProtectedRoute = () => {
	const { user } = useAuth();
	const location = useLocation();

	const [selected, setSelected] = React.useState('');

	return (
		<div>
			<PublicHeader selected={selected} select={setSelected} user={user} />
			<div className={`public-content ${selected === 'resources' ? 'with-sidebar' : ''}`}>
				<Outlet context={{ select: name => setSelected({ selected: name }) }} />
			</div>
		</div>
	);
};

export default ProtectedRoute;
